import { apiSlice } from "app/api/apiSlice";

export const attendeesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllAttendees: builder.query({
      query: (query) => {
        const { pagination, searchValue, filters, tag, attendee_group_id } = query; 
        const { pageIndex, pageSize } = pagination;
        const searchQuery = searchValue ? `&query=${searchValue}` : "";
        const tagQuery = tag ? `&tag=${encodeURIComponent(tag)}` : "";
        const groupQuery = attendee_group_id ? `&attendee_group_id=${attendee_group_id}` : "";
        
        const searchValueMatch = filters?.match(/searchValue=([^&]*)/)?.[1] || null;
        const searchValues = searchValueMatch == null ? '' : searchValueMatch;

        return {
          url: `/portal/event/attendee/?page=${pageIndex}&page_size=${pageSize}${searchQuery}${tagQuery}${groupQuery}&query=${searchValues}`,
        };
      },
      transformResponse: (response) => {
        const { page_metadata, data } = response.data;
        const attendees = data.map((item) => ({
          ...item,
          name: item.full_name,
          organization: item.organization?.name,
          orgId: item.organization?.id,
          group_name: item.group?.name,
          attendee_group_id: item.group?.id,
          created_by: item.created_by.email,
          tags: item.tags || [], 
        }));

        return {
          page_metadata,
          data: attendees,
        };
      },
      providesTags: ["Attendee"],
    }),
    getAttendeesByGroupId: builder.query({
      query: ({ groupId, pagination, searchValue, tag }) => {
        const { pageIndex, pageSize } = pagination;
        const searchQuery = searchValue ? `&query=${searchValue}` : "";
        const tagQuery = tag ? `&tag=${encodeURIComponent(tag)}` : "";
        console.log(groupId,'2222222');
        return {
          url: `/portal/event/attendee/?attendee_group_id=${groupId}&page=${pageIndex}&page_size=${pageSize}${searchQuery}${tagQuery}`,
        };
      },
      transformResponse: (response) => {
        const { page_metadata, data } = response.data;
        const attendees = data.map((item) => ({
          ...item,
          name: item.full_name,
          organization: item.organization?.name,
          orgId: item.organization?.id,
          group_name: item.group?.name,
          attendee_group_id: item.group?.id,
          created_by: item.created_by.email,
          tags: item.tags || [], 
        }));

        return {
          page_metadata,
          data: attendees,
        };
      },
      providesTags: ["Attendee"],
    }),
    getAttendeeTags: builder.query({
      query: () => ({
        url: "/portal/event/attendee/tags/",
      }),
      transformResponse: (response) => response.data, 
      providesTags: ["Tags"],
    }),
    exportAllAttendeData: builder.query({
      query: () => ({
        url: "/portal/event/attendee/export/",
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    createAttendee: builder.mutation({
      query: (body) => ({
        url: `/portal/event/attendee/create/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Attendee"],
    }),
    importAttendees: builder.mutation({
      query: (body) => ({
        url: "/portal/event/attendee/import/",
        method: "PUT",
        body,
      }),
      transformResponse: (baseQueryReturnValue) => baseQueryReturnValue,
      invalidatesTags: ["Attendee"],
    }),
    updateAttendee: builder.mutation({
      query: (body) => ({
        url: `/portal/event/attendee/update/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Attendee"],
    }),
    deleteAttendee: builder.mutation({
      query: (body) => ({
        url: `/portal/event/attendee/delete/`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["Attendee"],
    }),
    removeAttendeesFromGroup: builder.mutation({
      query: (body) => ({
        url: `/portal/event/attendee/group/attendee/remove/`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["Attendee"],
    }),
  }),
});

export const {
  useLazyExportAllAttendeDataQuery,
  useGetAllAttendeesQuery,
  useGetAttendeesByGroupIdQuery,
  useGetAttendeeTagsQuery, 
  useImportAttendeesMutation,
  useCreateAttendeeMutation,
  useUpdateAttendeeMutation,
  useDeleteAttendeeMutation,
  useRemoveAttendeesFromGroupMutation,
} = attendeesApiSlice;